import { CONSENT_COOKIE_NAME } from '../components/CookieBanner/cookieConsent.constants';

import { getCookieValue } from '.';

export const getAdStorageGranted = (): boolean => {
  try {
    const raw = getCookieValue(CONSENT_COOKIE_NAME);

    if (!raw) {
      return false;
    }

    const consent = JSON.parse(raw);
    return consent?.ad_storage === 'granted';
  } catch (_e) { // eslint-disable-line @typescript-eslint/no-unused-vars
    return false;
  }
};
